export const getStyles = () => ({
  bidSetting: {
    '& .bid-setting__container': {
      '& .control-label': {
        marginTop: 12,
        paddingLeft: 0,
      },

      '& .col-sm-4': {
        paddingLeft: 0,

        '& .input-group': {
          maxWidth: 140,
        },
      },
    },
  },
});
